export const COMPANY_ADMIN = 'COMPANY_ADMIN';
export const COMPANY_USER = 'COMPANY_USER';
export const COMPANY_INACTIVE_USER = 'COMPANY_INACTIVE_USER';

export const PROCORE_VIEWER = 'PROCORE_VIEWER';

export const COMPANY_MANAGER = 'COMPANY_MANAGER';

export const DEPARTMENT_ADMIN = 'DEPT_ADMIN';
export const DEPARTMENT_USER = 'DEPT_USER';

export const JOB_UPDATER = 'JOB_UPDATER';

export const EMAILER = 'EMAILER';
export const VIEWER = 'VIEWER';

export const AGENT = 'AGENT';
